import { makeAutoObservable } from 'mobx';
import { LeaveTypesStringType } from '../types';
import apiConfig from '../api/routes';

export type AnalyticsT = {
    statistics: {
        [k in Partial<LeaveTypesStringType>]: number
    }[]
    totalDaysCount: number
}

class Analytics{
  constructor() {
    makeAutoObservable(this);
  }
  initialAnalytics: AnalyticsT = { statistics: [], totalDaysCount: 0 };
  analyticsList: AnalyticsT = this.initialAnalytics;
  isFetchedAnalytics = false;

  fetchAnalytics = async (year: number, userId?: string) => {
    try {
      this.isFetchedAnalytics = false;
      this.analyticsList = await apiConfig.profileService.getAbsenceAnalytics(year, userId);
      this.isFetchedAnalytics = true;
    }
    catch (e) {
      this.isFetchedAnalytics = false;
    }
  };
}


export const AnalyticsStore = new Analytics();